import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createHead } from '@unhead/vue/client'
import 'unfonts.css'
import './styles/main.sass'
import sentry from './plugins/sentry'

createApp(App).use(router).use(createHead()).use(sentry).mount('#app')
